import type { AgeRange } from './ArtBook'

export const AGE_OPTIONS: Array<{ value: AgeRange; label: string }> = [
  { value: 'under-1', label: 'Under 1 year' },
  { value: '1-2', label: '1–2 years old' },
  { value: '3-4', label: '3–4 years old' },
  { value: '5-7', label: '5–7 years old' },
  { value: '8-10', label: '8–10 years old' },
  { value: '11-13', label: '11–13 years old' },
  { value: '14-17', label: '14–17 years old' },
  { value: '18+', label: '18 years or older' },
]

const SELECTABLE_AGE_RANGES = new Set<AgeRange>(AGE_OPTIONS.map(option => option.value))

export function isSelectableAgeRange(value: unknown): value is AgeRange {
  return typeof value === 'string' && SELECTABLE_AGE_RANGES.has(value as AgeRange)
}

export function ageRangeFromYears(ageYears: number): AgeRange {
  if (ageYears === 0) return 'under-1'
  if (ageYears <= 2) return '1-2'
  if (ageYears <= 4) return '3-4'
  if (ageYears <= 7) return '5-7'
  if (ageYears <= 10) return '8-10'
  if (ageYears <= 13) return '11-13'
  if (ageYears <= 17) return '14-17'
  return '18+'
}
